import React,{useState,Suspense, useRef, useEffect} from 'react'
import { Canvas } from '@react-three/fiber'
import Loader from '../components/Loader'
import House from '../models/House'
import Sky from '../models/Sky'
import HomeInfo from '../components/HomeInfo'
import {OrbitControls, PerspectiveCamera, Stats } from '@react-three/drei'
import TWEEN from '@tweenjs/tween.js'
import Tween from '../components/Tween'
import song from '../assets/sparkle.mp3'
import { soundoff, soundon } from '../assets/icons'
// import Lakshmi from '../models/Lakshmi'


const Home = () => {
    const audioRef=useRef(new Audio(song));
    audioRef.current.volume=0.4;
    audioRef.current.loop=true;
    const [isPlayingAudio, setIsPlayingAudio] = useState(false);

    useEffect(() => {
      if (isPlayingAudio) {
        audioRef.current.play();
      }
    
      return () => {
        audioRef.current.pause();
      }
    }, [isPlayingAudio])
    
    const [currentStage, setCurrentStage] = useState(0);

    const adjustHouseForScreenSize=()=> {
        let screenScale=null,screenPosition=[0,0,0],rotation=[0.1,4.7,0];

        if (window.innerWidth<768) {
            screenScale =[0.5,0.5,0.5];
        }
        else {
            screenScale =[0.5,0.5,0.5];
        }
        return [screenScale,screenPosition,rotation];
    }

    const adjustStatueForScreenSize=()=> {
        let screenScale,screenPosition,screenRotation=[0,0.75,0];

        if (window.innerWidth<768) {
            screenScale =[3,3,3];
            screenPosition=[0,-1.5,0];
        }
        else {
            screenScale =[0.0125,0.0125,0.0125];
            screenPosition=[1.25,-0.2,-1.5];
        }
        return [screenScale,screenPosition,screenRotation];
    }

    const [houseScale,housePosition]=adjustHouseForScreenSize();
    const [statueScale, statuePosition,statueRotation] = adjustStatueForScreenSize();

    const controls = useRef()
    const camera = useRef()

    const annotations = [
        {
            title: 'Start here',
            position: {
                x: 15.75, 
                y: 2, 
                z: -7.72
            },
            lookAt: {
              x: -38,
              y: 5,
              z: -10
            },
            currentStage: 1,
        },
        {
            title: 'About',
            position: {
              x: 12.000571100990121,
              y: 1.380444647637779, 
              z: -7.834930193297549
            },
            lookAt: {
              x: -30,
              y: 5,
              z: -20
            },
            currentStage: 2,
        },
        {
            title: 'Skills',
            position: {
              x: 8.500542545940404,
              y: 1.561422415255905,
              z: -7.84318368363273
            },
            lookAt: {
              x: 150.1,
              y: -10.5,
              z: -300
            },
            currentStage: 3,
        },
        {
          title: 'Projects',
          description: '<p>Looking Down from Above</p>',
          position: {
            x: 6.750542545940404,
            y: 3.061422415255905,
            z: -6.04318368363273
          },
          lookAt: {
            x: 800.1,
            y: -150.5,
            z: 200
          },
          currentStage: 4,
        },
        {
            title: 'Achievements',
            description: '<p>Looking Down from Above</p>',
            position: {
              x: 10.850542545940404,
              y: 3.061422415255905,
              z: -4.54318368363273
            },
            lookAt: {
              x: -400.1,
              y: -150.5,
              z: -1000
            },
            currentStage: 5,
        },
        {
            title: 'Experience',
            description: '<p>Looking Down from Above</p>',
            position: {
              x: 3.250542545940404,
              y: 1.861422415255905,
              z: -1.74318368363273
            },
            lookAt: {
              x: 0.1,
              y: 0.5,
              z: -1000
            },
            currentStage: 6,
        },
        {
            title: 'Socials',
            description: '<p>Looking Down from Above</p>',
            position: {
              x: 2.050542545940404,
              y: 1.361422415255905,
              z: -6.44318368363273
            },
            lookAt: {
              x: 500,
              y: 0.5,
              z: -700
            },
            currentStage: 7,
        },
        {
            title: 'Contact',
            description: '<p>Looking Down from Above</p>',
            position: {
              x: 3.050542545940404,
              y: 2.361422415255905,
              z: -8.90318368363273
            },
            lookAt: {
              x: 1.7,
              y: 3,
              z: 0
            },
            currentStage: 8,
        },
        
        
        
    ]

    const buttons = annotations.map(({ title, lookAt, position, currentStage }) => (
        <button
        className='button'
        onClick={() => {
            new TWEEN.Tween(controls.current.target)
            .to(
                {
                x: lookAt.x,
                y: lookAt.y,
                z: lookAt.z
                },
                2100
            )
            .easing(TWEEN.Easing.Cubic.Out)
            .start()

            new TWEEN.Tween(camera.current.position)
            .to(
                {
                x: position.x,
                y: position.y,
                z: position.z
                },
                2000
            )
            .easing(TWEEN.Easing.Cubic.Out)
            .start();
            setCurrentStage(currentStage);
        }}>
        <div style={{
            transition: "transform 0.1s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.15)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          {title}</div>
        </button>
    ))
    
    useEffect(()=>{
        // console.log(camera.current.position)
    },[])

    return (
    <section className='w-full h-screen relative justify-center items-center flex flex-col  bg-[#008cba]'>
        <div className='absolute top-28 left-0 right-0 z-10 flex items-center justify-center'>
            <HomeInfo currentStage={currentStage}/>
        </div>
        <Canvas 
            className={`w-full h-screen bg-transparent cursor-grab`}
        >
            <PerspectiveCamera ref={camera} makeDefault position={[10, 10, 10]} />
            <Suspense fallback={<Loader/>}>
                <directionalLight position={[1,1,1]} intensity={2}/> {/*like sun*/}
                <ambientLight intensity={0.5}/>
                <hemisphereLight skyColor="#b1e1ff" groundColor="#000000" intensity={1} />
                <Sky/>
                <OrbitControls
                    ref={controls}
                    enableDamping={true} 
                />
                <House
                    position={housePosition}
                    scale={houseScale}
                    controls={controls}
                />
                {/* <Lakshmi
                  position={statuePosition}
                  scale={statueScale}
                  rotation={statueRotation}
                /> */}
                <Tween/>
                <Stats/>
            </Suspense>

        </Canvas>
        <div className='flex flex-row items-center justify-center gap-5'>
          <div id='ui' className='relative bottom-0'>{buttons}</div>
          <div className='absolute bottom-2 left-1'>
            <img 
              src={isPlayingAudio?soundon:soundoff}
              alt='sound'
              className='w-10 h-10 cursor-pointer object-contain'
              onClick={()=>setIsPlayingAudio(!isPlayingAudio)}
            />
          </div>
        </div>
    </section>
  )
}

export default Home